module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[84]83.bfa76f8.woff2";